import { useCallback } from 'react'

export const ReactTasks = [
  {
    id: 'react-useState',
    categoryId: '4',
    title: 'useState',
    lang: 'jsx',
    code: `export const Counter = () => {
  const [count, setCount] = useState(0)

  function handleClick() {
    setCount(count + 1)
  }

  return <button onClick={handleClick}>You pressed me {count} times</button>
}`,
  },
  {
    id: 'react-useEffect',
    categoryId: '4',
    title: 'useEffect',
    lang: 'jsx',
    code: `const [serverUrl, setServerUrl] = useState('https://localhost:3000')

useEffect(() => {
  const connection = createConnection(serverUrl, roomId)

  connection.connect()

  return () => {
    connection.disconnect()
  }
}, [roomId, serverUrl])`,
  },
  {
    id: 'react-createPortal',
    categoryId: '4',
    title: 'createPortal',
    code: `export const MyComponent = () => {
  return (
    <div style={{ border: '2px solid black' }}>
      <p>This child is placed in the parent div.</p>
      {createPortal(
        <p>This child is placed in the document body.</p>,
        document.body
      )}
    </div>
  )
}`,
    lang: 'jsx',
  },
  {
    id: 'react-dashboard',
    categoryId: '4',
    title: 'Dashboard',
    code: `export const Dashboard = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchCategories())
  }, [])

  return <Layout />
}`,
    lang: 'jsx',
  },
  {
    id: 'react-toolbar',
    categoryId: '4',
    title: 'Toolbar',
    code: `const Toolbar = ({ onPlayMovie, onUploadImage }) => {
  return (
    <div>
      <Button onClick={onPlayMovie}>
        Play Movie
      </Button>
      <Button onClick={onUploadImage}>
        Upload Image
      </Button>
    </div>
  )
}`,
    lang: 'jsx',
  },
  {
    id: 'react-usecallback',
    categoryId: '4',
    title: 'useCallback',
    lang: 'jsx',
    code: `const Report = ({ item }) => {
  const handleClick = useCallback(() => {
    sendReport(item)
  }, [item])

  return (
    <figure>
      <Chart onClick={handleClick} />
    </figure>
  )
}`,
  },
  {
    id: 'react-useMemo',
    categoryId: '4',
    title: 'useMemo',
    lang: 'jsx',
    code: `export const TodoList = ({ todos, theme, tab }) => {
  const visibleTodos = useMemo(
    () => filterTodos(todos, tab),
    [todos, tab]
  )

  return (
      <List items={visibleTodos} />
  )
}`,
  },
  {
    id: 'react-useRef',
    categoryId: '4',
    title: 'useRef',
    lang: 'jsx',
    code: `export const Counter = () => {
  let ref = useRef(0)

  function handleClick() {
    ref.current = ref.current + 1
    alert('You clicked ' + ref.current + ' times!')
  }

  return <button onClick={handleClick}>Click me!</button>
}`,
  },
  {
    id: 'react-Fragment',
    categoryId: '4',
    title: 'Fragment',
    lang: 'jsx',
    code: `export const Blog = () => {
  const posts = [
    { id: 1, title: 'An update', body: "Yo!" },
    { id: 2, title: 'My new blog', body: 'I am starting a new blog!' },
  ]
  
  return posts.map(post => (
    <Fragment key={post.id}>
      <PostTitle title={post.title} />
      <PostBody body={post.body} />
    </Fragment>
  ))
}`,
  },
  {
    id: 'react-forwardRef',
    categoryId: '4',
    title: 'forwardRef',
    lang: 'jsx',
    code: `const MyInput = forwardRef(function MyInput(props, ref) {
  const { label, ...otherProps } = props

  return (
    <label>
      {label}
      <input {...otherProps} ref={ref} />
    </label>
  )
})`,
  },
  {
    id: 'react-memo',
    categoryId: '4',
    title: 'memo',
    lang: 'jsx',
    code: `const Greeting = memo(function Greeting({ name }) {
  const [greeting, setGreeting] = useState('Hello')

  return (
    <>
      <h3>{greeting}{name && ', '}{name}!</h3>
      <GreetingSelector value={greeting} onChange={setGreeting} />
    </>
  )
})`,
  },
  {
    id: 'react-conditional',
    categoryId: '4',
    title: 'conditional rendering',
    lang: 'jsx',
    code: `const Mailbox = props => {
  const unreadMessages = props.unreadMessages
  
  return (
    <div>
      <h1>Hello!</h1>
      {unreadMessages.length > 0 && <h2>You have {unreadMessages.length} unread messages.</h2>}
    </div>
  )
}`,
  },
]
